// extracted by mini-css-extract-plugin
export default {"row":"CorporateData_row__G19rE"};